import React, { useState, useEffect } from "react";
import {
  Box,
  Grid2,
  Typography,
  Tabs,
  Tab,
  Button,
  Rating,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { ReactComponent as UnAssigned } from "../../assets/logos/unassigned.svg";
import { ReactComponent as Assigned } from "../../assets/logos/assigned.svg";
import { ReactComponent as UnAssignedActive } from "../../assets/logos/unassigned_active.svg";
import { ReactComponent as AssignedActive } from "../../assets/logos/assigned_active.svg";
import { useNavigate, useLocation } from "react-router";
import { BasicLayout } from "../../layouts/BasicLayout";
import {
  userTabOptions,
  deliveryTabOptions,
  requestorTabOptions,
} from "../../data/UsersPage";
import SearchFilter from "../common/SearchFilter";
import UserListingTable from "./UserListingTable";
import UserListAPI from "../../utils/services/userList.api";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { getStorageValue } from "../../utils/helper";
import NotificationsListAPI from "../../utils/services/notifications.api";

function CustomTabPanel(props) {
  const { children, value, index } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

function UserPackage() {
  const location = useLocation();
  const navigate = useNavigate();
  const [tabValue, setTabValue] = useState(
    location?.state?.tab ? location?.state?.tab : 0
  );
  const { getUserRequestorListingCount, getUserDeliveryListingCount } =
    UserListAPI;
  const [countSubTabData, setCountSubTabData] = useState([]);
  const [secondaryTabValue, setSecondaryTabValue] = useState(
    location?.state?.statusId ? location?.state?.statusId : "Assigned"
  );
  const countData = [
    location?.state?.userData?.delivered,
    location?.state?.userData?.requested,
  ];
  const iconList = [<UnAssigned />, <Assigned />];
  const activeIconList = [<UnAssignedActive />, <AssignedActive />];
  const userId = getStorageValue("userId");
  const [isShowNotifications, setShowNotifications] = useState(false);
  const { checkUnreadNotifications } = NotificationsListAPI;

  const handlenavigateBack = () => {
    localStorage.setItem("SearchParams", "");
    localStorage.setItem("FilterParams", "");
    localStorage.setItem("SortByParams", "");
    localStorage.setItem("PageSize", "");
    navigate("/users");
  };

  const getStatusCount = async (value) => {
    if (value === 0) {
      const response = await getUserDeliveryListingCount(
        location?.state?.userData?.userId
      );
      if (response.status === "success") {
        setCountSubTabData([
          response.data.assigned,
          response.data.intransit,
          response.data.delivered,
        ]);
      }
    } else {
      const response = await getUserRequestorListingCount(
        location?.state?.userData?.userId
      );
      if (response.status === "success") {
        setCountSubTabData([
          response.data.unassigned,
          response.data.assigned,
          response.data.intransit,
          response.data.delivered,
          response.data.expired,
        ]);
      }
    }
  };
  const handleVisibilityChange = async () => {
    if (document.visibilityState === "visible") {
      const checkDate = new Date()?.toISOString();
      const response = await checkUnreadNotifications(userId, checkDate);
      if (response?.data?.message) {
        localStorage.removeItem("isClicked");
        localStorage.setItem("isReload", response?.data?.message);
        localStorage.setItem("notifications", response?.data?.message);
        setShowNotifications(response?.data?.message);
      }
    }
  };
  
  useEffect(() => {
    getStatusCount(tabValue);
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
    // eslint-disable-next-line
  }, []);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    setSecondaryTabValue(newValue === 0 ? "Assigned" : "Unassigned");
    setCountSubTabData([]);
    getStatusCount(newValue);
  };

  const handleTabClick = (newValue) => {
    setSecondaryTabValue(newValue);
  };

  return (
    <BasicLayout isShowNotifications={isShowNotifications}>
      <Grid2>
        <Button
          sx={{ color: "#2579CD", textTransform: "none", px: "0" }}
          variant="none"
          size="medium"
          startIcon={<ArrowBackIcon />}
          onClick={handlenavigateBack}
        >
          Back
        </Button>
        <Box
          sx={{
            display: "flex",
            marginTop: "1rem",
            justifyContent: "space-between",
          }}
        >
          <Box
            sx={{ display: "flex", justifyContent: "flex-start", width: "80%" }}
          >
            <Typography
              sx={{ paddingRight: "1rem", paddingTop: "4px" }}
              variant="h5"
              fontWeight={700}
              fontSize={15}
            >
              {location?.state?.userData?.firstName +
                " " +
                location?.state?.userData?.lastName}
            </Typography>
            <Box
              sx={{
                borderRadius: "7px",
                border: "1px solid #E6EDFF",
                padding: "2px",
                width: "160px",
                height: "32px",
                display: "flex",
                justifyContent: "flex-start",
              }}
            >
              <Rating
                name="user-rating"
                defaultValue={location?.state?.userData?.rating}
                precision={0.5}
                readOnly
              />
              <Typography
                sx={{
                  paddingRight: "1rem",
                  paddingTop: "4px",
                  paddingLeft: "0.5rem",
                }}
                variant="h5"
                fontWeight={700}
                fontSize={15}
              >
                {location?.state?.userData?.rating}
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "flex-start",
            }}
          >
            <Button
              style={{ textTransform: "none", backgroundColor: "#0C68F4"  }}
              variant="contained"
              size="medium"
              startIcon={<AddIcon />}
              onClick={() => {
                navigate("/create-package", {state: 
                  {
                    backURL: `/users/${location?.state?.userData?.userId}`,
                    tab: tabValue,
                    statusId: secondaryTabValue,
                    userData: location?.state?.userData,
                    userId: location?.state?.userData?.userId
                  }
                });
              }}
            >
              Create New
            </Button>
          </Box>
        </Box>
        <Grid2>
          <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={tabValue}
                onChange={handleTabChange}
                className="tab-img"
              >
                {userTabOptions.map((ele, idx) => {
                  return (
                    <Tab
                      sx={{ textTransform: "none", fontSize: "13px", paddingBottom: "0px", minHeight: '50px' }}
                      iconPosition="start"
                      icon={
                        idx === tabValue ? activeIconList[idx] : iconList[idx]
                      }
                      label={
                        <p>
                          <span
                            style={{
                              color: idx === tabValue ? "black" : "#7C8DB5",
                            }}
                          >
                            {" "}
                            {ele}{" "}
                          </span>{" "}
                          (
                          <span style={{ fontWeight: "500px" }}>
                            {countData[idx] !== undefined ? countData[idx] : 0}
                          </span>
                          )
                        </p>
                      }
                    />
                  );
                })}
              </Tabs>
            </Box>

            {userTabOptions.map((ele, idx) => {
              return (
                <CustomTabPanel key={ele + "Id"} value={tabValue} index={idx}>
                  {idx === 0 ? (
                    <Grid2 sx={{ marginTop: "1rem" }}>
                      {deliveryTabOptions.map((data, index) => (
                        <Button
                          sx={{
                            borderRadius: "8px",
                            border: "1px solid grey",
                            padding: "5px",
                            width: "12%",
                            textTransform: "none",
                            marginRight: "1rem",
                            lineHeight: 1.5,
                            color:
                              data === secondaryTabValue ? "white" : "black",
                            backgroundColor:
                              data === secondaryTabValue ? "#0C68F4" : "white",
                          }}
                          onClick={() => handleTabClick(data)}
                        >
                          {data} (
                          {countSubTabData.length > 0
                            ? countSubTabData[index]
                            : 0}
                          )
                        </Button>
                      ))}
                    </Grid2>
                  ) : (
                    <Grid2 sx={{ marginTop: "1rem" }}>
                      {requestorTabOptions.map((data, index) => (
                        <Button
                          sx={{
                            borderRadius: "8px",
                            border: "1px solid grey",
                            padding: "5px",
                            width: "12%",
                            textTransform: "none",
                            marginRight: "1rem",
                            lineHeight: 1.5,
                            color:
                              data === secondaryTabValue ? "white" : "black",
                            backgroundColor:
                              data === secondaryTabValue ? "#0C68F4" : "white",
                          }}
                          onClick={() => handleTabClick(data)}
                        >
                          {data} (
                          {countSubTabData.length > 0
                            ? countSubTabData[index]
                            : 0}
                          )
                        </Button>
                      ))}
                    </Grid2>
                  )}
                  <SearchFilter
                    childComponent={
                      <UserListingTable
                        userData={location?.state?.userData}
                        tab={idx}
                        statusId={secondaryTabValue}
                      />
                    }
                    filterCondition={true}
                    typeId={2}
                    searchPage="package"
                    defaultValue="1"
                    defaultFilterValue={"All"}
                  />
                </CustomTabPanel>
              );
            })}
          </Box>
        </Grid2>
      </Grid2>
    </BasicLayout>
  );
}

export default UserPackage;
